import { motion } from "framer-motion";
import {MAX_ROWS, systemBlack, systemGreyLight, systemWhite} from "../../constants";
import { createStyledElement } from "../../../../utils/createStyledElement";

export const ITEM_WIDTH = 252;
export const MOBILE_ITEM_WIDTH = 140;
export const ITEM_HEIGHT = 220;

const isMobileViewport = () =>
  typeof window !== "undefined" ? window.innerWidth <= 768 : false;

export const CategoriesSectionContent = createStyledElement(motion.section, () => ({
  padding: isMobileViewport() ? "30px 16px" : "50px 40px",
  backgroundColor: isMobileViewport() ? systemWhite : "#F7F9FC",
}));

export const CategoriesContainer = createStyledElement("div", () => ({
  display: isMobileViewport() ? "flex" : "grid",
  flexDirection: isMobileViewport() ? "row" : undefined,
  flexWrap: isMobileViewport() ? "wrap" : undefined,
  gridTemplateColumns: isMobileViewport()
    ? undefined
    : `repeat(auto-fill, minmax(${ITEM_WIDTH}px, 1fr))`,
  maxHeight: isMobileViewport() ? undefined : `calc(${ITEM_HEIGHT}px * ${MAX_ROWS})`,
  overflow: "hidden",
  gap: isMobileViewport() ? 20 : 0,
  marginTop: 50,
}));

export const CategoryItem = createStyledElement("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  font: '400 14px/20px "Roboto", sans-serif',
  backgroundColor: systemWhite,
  color: systemBlack,
  border: `1px solid ${systemGreyLight}`,
  margin: 0,
  minHeight: ITEM_HEIGHT,
});

export const CategoryImage = createStyledElement("img", {});

export const CategoryTitle = createStyledElement("span", {
  font: '400 14px/20px "Roboto", sans-serif',
  color: systemBlack,
});

export const Chip = createStyledElement("div", {
  backgroundColor: "#F7F9FC",
  padding: "12px 16px",
  borderRadius: 99,
  font: '400 12px/20px "Roboto", sans-serif',
  color: systemBlack,
  height: 44,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const HiddenCategoriesChip = createStyledElement("div", {
  backgroundColor: systemWhite,
  padding: "12px 16px",
  borderRadius: 99,
  font: '400 12px/20px "Roboto", sans-serif',
  color: systemBlack,
  height: 44,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "1px solid #BDBDBD",
});
